import { Form } from '@ef-global/web-ui-react/lib/components/Form';
import React, { useContext } from 'react';
import Link from '~components/utils/link';
import { IFormElement } from '~interfaces/components';
import SettingsContext from '~src/helpers/settingsContext';

interface IFormGroupProps extends IFormElement {
  formik: any;
  className?: string;
  enableLabels: boolean;
}

const FormGroup: React.FC<IFormGroupProps> = (props:any) => {
  const { children, label, id, formik, valid, className, enableLabels } = props;

  return (
    <Form.Group
      label={enableLabels ? label : null}
      valid={formik.touched[id] ? valid : undefined}
      className={className}
    >
      {children}
      {
        formik.touched[id] && formik.errors[id] ?
          <Form.ValidationMessage valid={false}>{formik.errors[id]}</Form.ValidationMessage>
          : <Form.ValidationMessage valid={true} />
      }
    </Form.Group>
  );
};

export interface IFormElementProps extends IFormElement {
  formik: any;
}

const FormInput = ({ placeholder, formik, id, type }: IFormElementProps) => {
  // Convert phone type to text
  const localType = type === 'phone' ? 'text' : type;

  return (
    <Form.Input
      id={id}
      floatingLabel={true}
      type={localType}
      placeholder={placeholder}
      onChange={formik.handleChange}
      onBlur={formik.handleBlur}
      value={formik.values[id]}
      className='u-mt-xxs'
    />
  );
};

const FormSelect = (props: IFormElementProps) => {
  const { options, id, formik, label } = props;

  return (
    <Form.Select
      id={id}
      floatingLabel={true}
      placeholder={label}
      onChange={formik.handleChange}
      onBlur={formik.handleBlur}
      value={formik.values[id]}
      className='u-mt-xxs'
    >
      {options?.map((option) => {
        return <option value={option.value} key={option.value}>{option.label}</option>;
      })}
    </Form.Select>
  );
};

const FormCheckbox = (props: IFormElementProps) => {
  const { options, id, formik, label } = props;

  return (
    <>
      {options ? options.map((checkbox) => {
        // Not very elegant...
        // Terms and conditions checkbox has the legal notice link from settings hardcoded to the label
        if (label === 'Terms and Conditions') {
          const { settings } = useContext(SettingsContext);
          return (
            <div
              key={checkbox.value}
              className='display-flex'
            >
              <Form.Checkbox
                id={id}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values[id]}
              >
                <Link
                  storyblokLink={settings.content?.legal_notices_link}
                  target={'_blank'}
                >
                  {checkbox.label}
                </Link>
              </Form.Checkbox>
            </div>
          );
        }
        return (
          <Form.Checkbox
            key={checkbox.value}
            id={id}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values[id]}
          >
            {checkbox.label}
          </Form.Checkbox>
        );
      },
      ) : null}
    </>
  );
};

const FormTextArea = ({ id, formik, placeholder }: IFormElementProps) => {
  return (
    <Form.Textarea
      id={id}
      placeholder={placeholder}
      onChange={formik.handleChange}
      onBlur={formik.handleBlur}
      value={formik.values[id]}
      style={{ width: '100%' }}
    />
  )
}

interface IFormElementsProps extends IFormElementProps {
  className?: string;
  enableLabels: boolean;
}

const FormElements = (props: IFormElementsProps) => {
  // Do not render hidden fields
  if (props.hidden === '1') { return null; }

  switch (props.type) {
    case 'text':
    case 'email':
    case 'phone':
      return (
        <FormGroup {...props}>
          <FormInput {...props} />
        </FormGroup>
      );
    case 'checkbox':
      return (
        <FormGroup {...props}>
          <FormCheckbox {...props} />
        </FormGroup>
      );
    case 'select':
      return (
        <FormGroup {...props}>
          <FormSelect {...props} />
        </FormGroup>
      );
    case 'textarea':
      return (
        <FormGroup {...props}>
          <FormTextArea {...props} />
        </FormGroup>
      )
    default:
      // tslint:disable-next-line:no-console
      console.log('This Form element is not implemented, type:', props.type);
      return <div key={props.id} />;
  }
};
// TODO: Add memoization or remove this code!

// const areEqual = (prevProps, nextProps) => {
//   const isValueEqual = prevProps.formik.values[prevProps.id] === nextProps.formik.values[nextProps.id];
//   return isValueEqual;
// };

// const FormElements = React.memo((props: IFormElementProps) => {
//   switch (props.type) {
//     case 'text':
//       return formInput(props as IFormElementProps);
//     // case 'form-select':
//     //   return formSelect(props as IFormSelectProps);
//     default:
//       // tslint:disable-next-line:no-console
//       console.log('This Form element is not implemented');
//       return <div key={props.key}/>;
//   }
// }, areEqual);

export default FormElements;
